import { POST } from "../../APiHelper/API";

export const bulkUpdatePlayers = (team_id, players, onSuccess, onError) => {
  POST(
    `/api/v1/leagues/team/${team_id}/bulk_update_players`,
    { players: players },
    onSuccess,
    onError
  );
};
